import { FlatNode } from '../../../pages/mindmap/types';
import { Image } from 'primereact/image';

import "./node-preview.css";

interface NodePreviewProps {
  node: FlatNode;
}

export const NodePreview = ({ node }: NodePreviewProps) => {
  return (
    <div style={{ height: node.previewMinHeight, width: node.width }}>
      <Image
        src="https://picsum.photos/1920/1080"
        width={node.width.toString()}
        height={node.previewMinHeight.toString()}
        preview
      />
    </div>
  );
};
